import { AllDevicesListApiResponse, IApiResponse, IFetchdevice } from "@/services/device/device.type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DeviceState {
    device: IApiResponse;
    loading: boolean;
    error: boolean;
    devicesList:AllDevicesListApiResponse;
    lastSelectedOperatorId? :string
    lastSelectedMarketId?:string
    message?:string;
}

// Defining the initial state for the device slice
const initialState: DeviceState = {
    device: {
        data: [],
        pagination: {
            totalRecords: 0,
            currentPage: 0,
            totalPages: 0,
            nextPage: 0,
            previousPage: 0,
        },
        success: false,
        message: "",
    },
    devicesList: {
    success: false,
    message: "",
    data: [], 
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
  } ,
    lastSelectedOperatorId: undefined,
    lastSelectedMarketId: undefined,
    loading: false,
    error: false,
}
// Creating action creators and reducers for device-related actions
const deviceSlice = createSlice({
    name: "device",
    initialState,
    reducers: {
         // Action to start the process of fetching device data
        getDevice: (state, action: PayloadAction<IFetchdevice>) => {
            state.loading = true;
        },
        // Action to handle successful device data retrieval
        getDeviceSuccess: (state, action: PayloadAction<IApiResponse>) => {
            state.loading = false;
            state.device = { ...action.payload }; 
        },
        // Action to handle failure when fetching device data
        getDeviceFailure: (state) => {
            state.loading = false;
            state.error = true;
            state.device = { ...initialState?.device }
        },
                //List API 
        getDevicesList: (state,action: PayloadAction<IFetchdevice>) => {
            state.loading = true;
            state.message = ""

        },
        getDevicesListSuccess: (
            state,
            action: PayloadAction<
                AllDevicesListApiResponse & { operatorId?: string; marketId?: string }
            >
        ) => {
            state.loading = false;

            const {
                data,
                pagination,
                success,
                message,
                operatorId,
                marketId,
            } = action.payload;

            const isSameOperator = state.lastSelectedOperatorId === operatorId;
            const isSameMarket = state.lastSelectedMarketId === marketId;
            const isNextPage =
                pagination?.currentPage > 1 &&( isSameOperator && isSameMarket);
            state.error = false;
            state.message = action.payload.message;
            state.devicesList = {
                success,
                message,
                pagination,
                data: isNextPage
                    ? [...state.devicesList.data, ...data]
                    : [...data],
            };

            state.lastSelectedOperatorId = operatorId;
            state.lastSelectedMarketId = marketId;
        },
        getDevicesListFailure: (state,action:any) => {
            state.loading = false;
            state.error = true;
            state.message = action.payload?.messageDetails?.length ?  action.payload?.messageDetails[0]?.message : action.payload?.message
        },
        clearDeviceError: (state) => {
            state.error = false;
            state.message = ''; // Reset message to empty string as per initial state
    },
    }
});

const deviceReducer = deviceSlice.reducer;

export const { getDevice, getDeviceSuccess, getDeviceFailure , getDevicesList, getDevicesListSuccess,getDevicesListFailure,clearDeviceError } = deviceSlice.actions
export default deviceReducer;